import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material UI imports
import { Box } from '@mui/material';
// Component imports
import QuestionHeader from '../../components/questionHeader';
import CustomTextField from '../../components/customTextField';
// Utility imports
import { fetchSiteCoreContents } from '../../utility/utils';

const WoundOdorOther = ({
  contentID,
  handleOdorOtherChange,
  odorOtherText,
  movePlaceholder,
}) => {
  const [questionTextValue, setQuestionTextValue] = useState('');
  const [questionResponseTextValue, setQuestionResponseTextValue] = useState(
    ''
  );

  useEffect(() => {
    if (!contentID) return;
    fetchSiteCoreContents(contentID)
      .then((typeContent) => {
        const woundCharacteristics =
          typeContent?.item?.contentDetailsLists?.[0]?.contentItems?.[0]
            ?.woundCharacteristics || {};
        const {
          question2Text = '',
          question2ResponseText = '',
        } = woundCharacteristics;

        setQuestionResponseTextValue(
          question2ResponseText.replace(/<[^>]+>/g, '')
        );
        setQuestionTextValue(question2Text.replace(/<[^>]+>/g, ''));
      })
      .catch((error) => {
        console.error('Failed to fetch site core contents:', error);
      });
  }, [contentID]);

  return (
    <Box>
      <QuestionHeader
        questionTextValue={questionTextValue}
        showInfo={false}
        headerStyle={{
          paddingBottom: '16px',
          fontSize: '25px',
          fontWeight: 'bold',
        }}
      />
      <CustomTextField
        inputVariant="outlined"
        inputType="text"
        handleChange={handleOdorOtherChange}
        inputValue={odorOtherText}
        placeHolderText={questionResponseTextValue}
        inputStyle={{ width: '100%', maxWidth: '573px' }}
        containerBoxStyle={{ padding: '8px 0 30px 0' }}
        movePlaceholder={movePlaceholder}
      />
    </Box>
  );
};

WoundOdorOther.propTypes = {
  contentID: PropTypes.string.isRequired,
  handleOdorOtherChange: PropTypes.func.isRequired,
  odorOtherText: PropTypes.string.isRequired,
  movePlaceholder: PropTypes.bool.isRequired,
};

export default WoundOdorOther;
